module.exports = __webpack_public_path__ + "img/18_new.79b98949.png";